// extracted by mini-css-extract-plugin
export default {"toggleButton":"ThemeToggle_toggleButton__0lP2+"};